export default "/images/logo-shipro-dark.svg?469a286c95ca575b67c050a8e9ba3024";